import styles from './style.styl'
import { ArrowButton } from '../icons'
import { cc } from '../../utils'

const FooterForm = () => {
  return (
    <form className={styles.form} method='POST'
      action='https://futurelondonacademy.activehosted.com/proc.php' id='_form_110_' noValidate
      data-styles-version='5'>
      <input type='hidden' name='u' value='110' />
      <input type='hidden' name='f' value='110' />
      <input type='hidden' name='s' />
      <input type='hidden' name='c' value='0' />
      <input type='hidden' name='m' value='0' />
      <input type='hidden' name='act' value='sub' />
      <input type='hidden' name='v' value='2' />
      <input type='hidden' name='or' value='aecd97883b280aa04b22ec440e5d8ddd' />
      <div className={`${styles.content} _form-content`}>
        <div className='_form_element _field29 _inline-style '>
          <input type='hidden' name='field[29]' value='' />
        </div>
        <div className='_form_element _field30 _inline-style '>
          <input type='hidden' name='field[30]' value='' />
        </div>
        <input type='hidden' name='field[31]' value='' />
        <input type='hidden' name='field[32]' value='' />
        <input type='hidden' name='field[33]' value='' />
        <input type='hidden' name='field[34]' value='' />
        <input type='hidden' name='field[35]' value='' />
        <div className='_form_element _x96663833 _inline-style '>
          <div className='_field-wrapper'>
            <input type='text' id='fullname' name='fullname' placeholder='Your name'
              className={styles.input} />
          </div>
        </div>
        <div className={styles.buttonEmailWrap}>
          <div className='_form_element _x80953364 _inline-style '>
            <div className='_field-wrapper'>
              <input type='text' id='email' name='email' className={cc(styles.input, styles.email)}
                placeholder={'Your email address'} required />
            </div>
          </div>
          <button id='_form_110_submit' className={cc(styles.button, '_submit')} type='submit'>
            <ArrowButton className={styles.icon} />
          </button>
        </div>
      </div>
      <div className={`_form-thank-you ${styles.formThankYou}`} style='display:none;' />
    </form>
  )
}

export default FooterForm



// WEBPACK FOOTER //
// ./components/footer-form/index.js